import React, { useEffect, useState } from 'react';

import ApiUrls from '../../../services/apiUrls';
import BodyItem from './components/BodyItem';
import { KuposCommonLoader } from '../../common';
import KuposDataNotFound from '../../common/KuposDataNotFound';
import MonthYearPicker from '../../common/MonthYearPicker';

function MainTabsBodyMyTransactions(props) {
  let date = new Date();

  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedYear, setSelectedYear] = useState(date.getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(date.getMonth());
  const [month, setMonth] = useState(null);

  const loadTransactions = (month, year) => {
    props.actions.getMyTransactions({
      url: ApiUrls.myTransactions(month + 1 + '-' + year),
    });
  };

  useEffect(() => {
    loadTransactions(selectedMonth, selectedYear);
  }, []);

  const onMonthChange = (maskedValue, selectedYear, selectedMonth) => {
    console.log(maskedValue, selectedMonth);

    setSelectedYear(selectedYear);
    setSelectedMonth(selectedMonth);

    loadTransactions(selectedMonth, selectedYear);
  };

  const onInputChange = text => {
    setMonth(text);
  };

  const onSeeMoreClicked = i => {
    if ((selectedIndex || selectedIndex === 0) && selectedIndex === i) {
      setSelectedIndex(null);
    } else {
      setSelectedIndex(i);
    }
  };

  const getLabelName = rawLabel => {
    switch (rawLabel) {
      case 'Cancelación':
        return 'RESULTS_PAGE.CANCELLATION';
        break;
      case 'Compra':
        return 'RESULTS_PAGE.PURCHASE';
        break;
      case 'Transferencia realizada':
        return 'RESULTS_PAGE.SUCCESSFUL_TRANSFER';
        break;
      case 'Transferencia recibida':
        return 'RESULTS_PAGE.SUCCESSFUL_RECEIVE';
        break;
      default:
        return rawLabel;
        break;
    }
  };

  const getTranslations = rawReason => {
    if (rawReason.includes('Debit - Payment for booking')) {
      return (
        props.t('TRANSLATIONS.DEBIT_FOR_BOOKING') +
        ' ' +
        rawReason.split(' ')[rawReason.split(' ').length - 1]
      );
    } else if (rawReason.includes('Credit - Cancellation refund for booking')) {
      return (
        props.t('TRANSLATIONS.CREDIT_FOR_CANCELLATION') +
        ' ' +
        rawReason.split(' ')[rawReason.split(' ').length - 1]
      );
    } else if (rawReason.includes('Monto transferido a')) {
      return (
        props.t('TRANSLATIONS.AMOUNT_TRANSFERRED_TO') +
        ' ' +
        rawReason.replace('Monto transferido a ', '')
        // rawReason.split(' ')[rawReason.split(' ').length - 1]
      );
    } else if (rawReason.includes('Monto recibido de')) {
      return (
        props.t('TRANSLATIONS.AMOUNT_RECEIVED_FROM') +
        ' ' +
        rawReason.split(' ')[rawReason.split(' ').length - 1]
      );
    } else {
      return rawReason;
    }
  };

  const { t } = props;
  return (
    <div className="sub-section-description scroll-style my-transactions">
      <div className="my-account-title center-text">
        <div className="recharge-wallet-top-strip">
          <div className="back-button-format-my-account" onClick={() => props.onMenuChange()}>
            <img className="qr-back" src="/images/back_arrow_bip.png" />
          </div>
          <div>
            <div className="sub-section-account-general-title font13">
              {t('PROFILE.MY_TRANSACTIONS_HEADING.NORMAL')}{' '}
              <span className="bold-text">{t('PROFILE.MY_TRANSACTIONS_HEADING.BOLD')}</span>
            </div>
            <div className="sub-section-account-general-description font11">
              {t('PROFILE.MOVEMENT_SUB_HEADING')}
            </div>
          </div>
          <div></div>
        </div>
      </div>
      <div className="movements-in-capsule-menu font10">
        <MonthYearPicker
          selectedYear={selectedYear}
          selectedMonth={selectedMonth}
          onMonthChange={onMonthChange}
        ></MonthYearPicker>
      </div>

      {props.data &&
      props.data.myTransactions &&
      props.data.myTransactions.length &&
      !props.data.myTransactions.error ? (
        <div className="transactions-body-item my-movements-heading less-bold-text font10">
          <div className="transactions-first-child">
            <span className="bold-text ">{t('PROFILE.DATE')}</span> <br />
          </div>

          <div className="vl"></div>

          <div className="my-movements-middile-item">
            <span className="bold-text my-movement-title-span">{t('PROFILE.MOVEMENT')}</span> <br />
          </div>

          <div className="vl"></div>

          <div>
            <div>
              <span className="bold-text">{t('PROFILE.AMOUNT')}</span> <br />
            </div>
          </div>
        </div>
      ) : null}

      {props.data.getMyTransactionsPending ? (
        <div className="my-trips-loader">
          <KuposCommonLoader />
        </div>
      ) : null}

      {props.data && props.data.myTransactions && !props.data.myTransactions.error
        ? props.data.myTransactions.map((val, key) => (
            <BodyItem
              t={props.t}
              val={val}
              keyValue={key}
              getLabelName={getLabelName}
              onSeeMoreClicked={onSeeMoreClicked}
              selectedIndex={selectedIndex}
              getTranslations={getTranslations}
            />
          ))
        : null}
      {props.data &&
      props.data.getMyTransactionsError &&
      props.data.getMyTransactionsError.data &&
      props.data.getMyTransactionsError.data.error ? (
        <div className="trips-error-msg">
          <span>{props.data.getMyTransactionsError.data.error}</span>
        </div>
      ) : null}

      {props.data && props.data.myTransactions && props.data.myTransactions.length === 0 ? (
        <KuposDataNotFound
          icon="/images/circular/no-transaction.png"
          title={t('PROFILE.NO_TRANSACTIONS')}
          subTitle={t('PROFILE.RECHARGE_YOUR_WALLET')}
          infoText={t('PROFILE.RECHARGE_HERE')}
          onInfoClick={() => props.onTopIconChange(0)}
        />
      ) : null}
    </div>
  );
}

export default MainTabsBodyMyTransactions;



// WEBPACK FOOTER //
// ./src/features/my-account/MainTabsBodyMyTransactions/MainTabsBodyMyTransactions.js